import React from "react";
import TooltipGeneric from "../../../../shared/components/generic/tooltip/tooltip-generic";
import MonetaryUtils from "../../../../shared/utils/MonetaryUtils";
import DateUtils from "../../../../shared/utils/DateUtils";
import IconAction from "../../../../shared/components/generic/button/icon-action/icon-action";

const growthTooltipText = `O intervalo de cada meta de crescimento está entre o valor cadastrado nela e o valor inicial da próxima meta do mesmo tamanho de cliente. Ex:
        TAMANHO | CRESCIMENTO
        A  | 5%
        A  | 10%
    A primeira faixa vai de 5% a 9,99%.
    Se a segunda faixa muda para 15%, a primeira passa a estar entre 5% e 14,99%.`;

export const netSalesColumnsConfig = ({
    onEdit,
    onDelete
}) => [
    {
        key: "segmentation",
        label: "Tamanho do Cliente",
        width: "18%",
        render: row => row.segmentation || "-"
    },
    {
        key: "growth",
        label: (
			<span className="admin-table-header-tooltip">
				<span>Crescimento ≥</span>

				<TooltipGeneric
					content={growthTooltipText}
					ariaLabel="Explicação sobre crescimento"
				/>
			</span>
		),
        width: "18%",
        render: row => `≥ ${MonetaryUtils.formatPercentage(row.growth)}`
    },
    {
        key: "discount",
        label: "Desconto",
        width: "18%",
        render: row => MonetaryUtils.formatPercentage(row.discount) || "-"
    },
    {
        key: "createdAt",
        label: "Data de criação",
        width: "17%",
        render: row => DateUtils.formatDateToBrazilian(row.createdAt)
    },
    {
        key: "updatedAt",
        label: "Data da Última Atualização",
        width: "17%",
        render: row => DateUtils.formatDateToBrazilian(row.updatedAt)
    },
    {
        key: "actions",
        label: "Ações",
        width: "12%",
        render: row => (
            <IconAction
                row={row}
                actions={[
                    {
                        key: "edit",
                        variant: "edit",
                        title: "Editar",
                        onClick: onEdit
                    },
                    {
                        key: "delete",
                        variant: "delete",
                        title: "Excluir",
                        onClick: onDelete
                    }
                ]}
            />
        )
    }
];